var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Page } from "../../lib/page-component";
import KnockoutModel from "../../lib/knockout_model";
import "../../components/paging";
import './demo.css';
var Demo = /** @class */ (function (_super) {
    __extends(Demo, _super);
    function Demo(root) {
        return _super.call(this, "", root, {}) || this;
    }
    Demo.prototype.test = function (e) {
        console.log("eeeeeeeee");
        console.log(e);
        console.log(this.viewModel());
    };
    return Demo;
}(KnockoutModel));
var DemoModel = /** @class */ (function (_super) {
    __extends(DemoModel, _super);
    function DemoModel() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DemoModel.prototype.init = function () {
        this.vm = new Demo(this.container.querySelector('.box'));
        console.log("eeeeeeeee");
        this.vm.bind();
    };
    DemoModel.prototype.update = function (arg) {
        return Promise.resolve();
    };
    DemoModel.prototype.onInitComplete = function () {
    };
    return DemoModel;
}(Page));
export default DemoModel;
